import { createAsyncThunk } from '@reduxjs/toolkit';
import { Suppliers } from 'components/page-content/lotterie-slug';
import { setIsOpenLoginModalValue } from 'features/modal/modalSlice';
import { RootState } from 'lib/centralStore';
import {
  SUPPLIER_LOTTO_MODEL_API_KEY,
  SUPPLIER_LOTTOMATICA_GIOCO_DEL_LOTTO_MOBILE_MODEL_API_KEY,
  SUPPLIER_LOTTOMATICA_GIOCO_DEL_LOTTO_MODEL_API_KEY,
} from 'lib/datoCms/constants';
import { DatoCmsSupplierLottery } from 'lib/datoCms/types';
import { getTokenBySupplierType } from 'lib/launchGame/utils';
import { isClientSide } from 'utility/constant';

export const getWindowFeature = () => {
  if (isClientSide) {
    const { width: w, height: h } = window.screen;
    const width = w * 0.5;
    const height = h * 0.5;
    const topPosition = (h - Number(`${height}`)) * 0.5;
    const leftPosition = (w - Number(`${width}`)) * 0.5;
    const features = `fullscreen=0,titlebar=0,toolbar=0,location=yes,status=0,menubar=0,scrollbars=0,resizable=0,width=${width},height=${height},left=${leftPosition},top=${topPosition},screenX=${leftPosition},screenY=${topPosition}`;
    return features;
  }
  throw new Error('Window is not available on serverSide');
};

type LaunchLotteryProps = {
  window: Window;
  supplier: DatoCmsSupplierLottery;
  slug?: string;
  isMobile: boolean;
};

export type FrameProps = {
  token: string;
  cardNumber: string;
  supplier: DatoCmsSupplierLottery;
};

export const getLottery = createAsyncThunk<string, LaunchLotteryProps>(
  'launchLottery',
  async ({ supplier, slug, isMobile, window: newWindow }, { getState, dispatch }) => {
    const state = getState() as RootState;

    if (!state.auth.isLogged) {
      dispatch(setIsOpenLoginModalValue(true));
      throw new Error('User not logged');
    }
    const { supplierGame, supplierType } = supplier ?? {};
    const { cardNumber } = state.auth.user ?? {};
    const idConto = cardNumber?.slice(-8);
    const params = new URLSearchParams();
    const token = await getTokenBySupplierType(supplierType);

    if (!token) throw new Error('Token not found');
    params.set('token', `${token}`);

    switch (supplierType) {
      case Suppliers.Lottomatica:
        params.set('idContoGioco', idConto ?? '');
        params.set('idRivenditore', process.env.NEXT_PUBLIC_SISAL_ID_RIVENDITORE_LOTTOMATICA ?? '');
        params.set('skin', 'white');

        const baseSrc = process.env.NEXT_PUBLIC_LOTTOMATICA_IFRAME?.split('?').shift() ?? '';
        const supplierKey =
          supplierGame.toUpperCase() === SUPPLIER_LOTTO_MODEL_API_KEY.toUpperCase()
            ? isMobile
              ? SUPPLIER_LOTTOMATICA_GIOCO_DEL_LOTTO_MOBILE_MODEL_API_KEY
              : SUPPLIER_LOTTOMATICA_GIOCO_DEL_LOTTO_MODEL_API_KEY
            : supplierGame;

        return isMobile
          ? `${baseSrc}/msite/contents/${supplierKey.toLowerCase()}.html?${params.toString()}&mobile=true`
          : `${baseSrc}/vetrina${supplierKey}/login.do?${params.toString()}&dominio=`;
      default:
        // URL FOR OPEN IFRAME
        return `player?idConto=${idConto}&token=${token}&slug=${slug}`;
    }
  }
);
